import { Ability } from '@casl/ability'
import { initialAbility } from './config'
import store from '@/store'
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
const userData = store.state.app.userData
const existingAbility = userData ? userData.ability : null

export default new Ability(existingAbility || initialAbility)
